import { styled, CardHeader, Card, Typography, alpha } from "@mui/material";

export const JobTitle = styled(Typography)(({ theme }) => ({
  fontSize: "35px",
  color: theme.palette.primary.main,
  fontWeight: 900,
  fontFamily: "Cabin,sans-serif",
  textTransform: "uppercase",
  textAlign: "center",
}));

export const JobBody = styled(Typography)(({ theme }) => ({
  fontSize: "18px",
}));

export const StyledCard = styled(Card)(({ theme }) => ({
  borderRadius: "10px",
  backdropFilter: "blur(1px)",
  WebkitBackdropFilter: "blur(1px)",
  backgroundColor: alpha(theme.palette.background.paper, 0.05),
  width: "auto",
}));

export const StyledCardHeader = styled(CardHeader)(({ theme }) => ({
  ".MuiTypography-root": { fontSize: "1rem" },
  padding: "16px",
  width: "auto",
  textAlign: "center",
}));
